import { DialogContent, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { I18nTranslator, translations } from "utils/i18n";
import { MDialog } from ".";
import { EMDialogType } from "./MDialog";

interface IDeleteConfirmDialog {
  open: boolean;
  isDeleting: boolean;
  value?: string;
  handleClose(): void;
  handleDelete(): void;
}

const DeleteConfirmDialog = (props: IDeleteConfirmDialog) => {
  const { open, isDeleting = false, value, handleClose, handleDelete } = props;
  return (
    <MDialog
      open={open}
      type={EMDialogType.WARNING}
      title={I18nTranslator(translations.dialog.warning)}
      handleClose={handleClose}
      handleDelete={handleDelete}
      loading={isDeleting}
    >
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography marginRight={"6px"}>
            {I18nTranslator(translations.masterData.uWantToDel)}
            <Typography fontWeight={"700"} style={{ display: "inline" }}>
              {" "}
              {value}
            </Typography>
          </Typography>
        </Box>
        <Typography color={"error"}>
          {I18nTranslator(translations.masterData.noteDel)}
        </Typography>
      </DialogContent>
    </MDialog>
  );
};
export default DeleteConfirmDialog;
